module.exports = __webpack_public_path__ + "img/symbol_hashblack.83eab4d1.png";